import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const CHALET_COORDS = [47.3192, 14.4133];

export default function ChaletMap() {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (mapRef.current || !ref.current) return;

    const map = L.map(ref.current, {
      center: CHALET_COORDS,
      zoom: 13,
      scrollWheelZoom: false,
      zoomControl: false,
      attributionControl: true,
    });

    L.control.zoom({ position: "bottomright" }).addTo(map);

    // OpenTopoMap — shows terrain & elevation contours, perfect for alpine setting
    L.tileLayer(
      "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
      {
        attribution:
          '&copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        maxZoom: 17,
      }
    ).addTo(map);

    // Pulsating marker effect via two layered circles
    L.circleMarker(CHALET_COORDS, {
      radius: 22,
      color: "hsl(22, 72%, 52%)",
      fillColor: "hsl(22, 72%, 52%)",
      fillOpacity: 0.15,
      weight: 1.5,
      className: "map-pulse-ring",
    }).addTo(map);

    const marker = L.circleMarker(CHALET_COORDS, {
      radius: 9,
      color: "#fff",
      fillColor: "hsl(22, 72%, 52%)",
      fillOpacity: 1,
      weight: 3,
    }).addTo(map);

    marker
      .bindPopup(
        `<div style="font-family:Manrope,sans-serif;font-size:13px;line-height:1.6;padding:4px 2px">
          <strong style="font-family:'Cormorant Garamond',serif;font-size:18px;display:block;margin-bottom:2px;color:hsl(155,32%,16%)">Chalet Steiermark</strong>
          <span style="color:hsl(22,72%,52%);font-size:11px;letter-spacing:0.08em;text-transform:uppercase;font-weight:600">Pusterwald</span><br/>
          <span style="opacity:0.7;font-size:12px">Steiermark, Österreich</span>
        </div>`,
        { className: "chalet-popup", closeButton: false, offset: [0, -4] }
      )
      .openPopup();

    mapRef.current = map;

    return () => {
      map.remove();
      mapRef.current = null;
    };
  }, []);

  return (
    <div
      ref={ref}
      data-testid="chalet-map"
      className="w-full h-full min-h-[420px]"
      style={{ background: "hsl(var(--moss))" }}
    />
  );
}
